export const currencyCents = (v: number) =>
  Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
    v / 100,
  );

export * from "./i18n";
